import * as Yup from "yup";
import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import DiscountForm from "../Forms/DiscountForm";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { DiscountApi, EditDiscountBody } from "../../../../api/payment";
import { Button, Grid, LinearProgress, Typography } from "@mui/material";

type Props = {
  initialPatientDiscountValues?: any;
};

const EditPatientDiscounts = ({ initialPatientDiscountValues }: Props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [patientDiscount, setPatientDiscount] = useState<any>();

  const getPatientDiscounts = () => {
    const PatientDiscounts = new DiscountApi(config);
    PatientDiscounts
      .getDiscount(initialPatientDiscountValues[0])
      .then((res) => {
        setPatientDiscount(res?.data);        
      })
      .catch((err) => {        
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getPatientDiscounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editPatientDiscount = (values: EditDiscountBody) => {
    const patientDiscount = new DiscountApi(config);
    patientDiscount
      .updateDiscount(initialPatientDiscountValues[0], values)
      .then((res) => {
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: EditDiscountBody, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    const valuesEdited: any = {
      amount: values?.amount,
      currency: values?.currency,
    };
    editPatientDiscount(valuesEdited);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ bgcolor: "#fff", p: 1 }}>
          {!isLoading ? (
            <>
              <Typography variant="h3" gutterBottom sx={{ p: 0 }}>
                Edit Patient Discount
              </Typography>
              <Formik
                initialValues={{
                  patient_id: patientDiscount?.patient_id || '',
                  amount: patientDiscount?.amount || 0,                  
                }}
                enableReinitialize={true}
                validationSchema={
                  Yup.object().shape({
                    patient_id: Yup.string().required('Patient Name is required'),
                    amount: Yup.number()
                    .typeError('Amount must be a number')
                    .positive('Amount must be a positive number')
                    .required('Amount is required')                    
                  })
                }
                onSubmit={handleSubmit}
              >
                {({ dirty }) => {
                  return (
                    <Form>
                      <DiscountForm />
                      <Grid className={classes.buttons}>
                        <Grid className={classes.wrapper}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            disabled={!dirty}
                          >
                            Edit Discount
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </>
          ) : (
            <LinearProgress color="secondary" />
          )}
        </Box>
      </Box>
    </>
  );
};

export default EditPatientDiscounts;
